import React from 'react';
import './AboutSection.css';


const AboutSection = () => {
  return (
    <section className="about section fade-in-up" id="about">
      <div className="container about-wrapper">
        <div className="about-content">
          <span className="badge">Welcome to ICES2026</span>
          <h2>About Our Event</h2>
          <p>
            The International Conference on Engineering Structures (ICES) is a multidisciplinary forum initiated by the <em>Engineering Structures</em> journal (a top-tier Q1 journal) to promote innovation, discussion, and academic exchange in structural engineering, mechanics, materials, and construction. The first ICES was held in Guangzhou, China in November 2024, attracting several hundred participants. The second conference is scheduled for December 2026 in Brisbane, Australia.
          </p>
        </div>
        <div className="about-image">
          <img src="/images/about-Img.png" alt="About ICES2026" />
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
